import { z } from 'zod'

/** Platform settings' line tabs, in order, and their labels. Market rules is the one it opens on. */
export const PLATFORM_SETTINGS_TABS = {
  rules: 'Market rules',
  operators: 'Operators',
  alerts: 'Alerts',
} as const

export type PlatformSettingsTab = keyof typeof PLATFORM_SETTINGS_TABS

const TAB_KEYS = Object.keys(PLATFORM_SETTINGS_TABS) as [
  PlatformSettingsTab,
  ...PlatformSettingsTab[],
]

/**
 * Platform settings' search: the tab, in the address so a link opens that tab. An unreadable one
 * is dropped, which opens Market rules.
 */
export const platformSettingsSearchSchema = z.object({
  tab: z.enum(TAB_KEYS).optional().catch(undefined),
})

export type PlatformSettingsSearch = z.infer<typeof platformSettingsSearchSchema>
